import { OrmStory } from '@aclass/admin/storage/actions';
import { IEpicDi } from '@aclass/admin/storage/helpers';
import { IAdminState } from '@aclass/admin/storage/states';
import { Action } from '@aclass/core/storage/action';
import { ofType, ActionsObservable, StateObservable } from 'redux-observable';
import { merge } from 'rxjs';
import { ignoreElements, tap } from 'rxjs/operators';

export const ormModuleEpic = (action: ActionsObservable<Action>, state: StateObservable<IAdminState>, { ormManager }: IEpicDi) => merge(
    action.pipe(
        ofType(OrmStory.RELOAD_MODEL),
        tap(({ payload }: Action<string>) => {
            ormManager.onReload.emit(payload);
        }),
        ignoreElements()
    ),
);
